import React from 'react'
import { useState, useEffect } from 'react'
import GetfacilityTypeData from './MyMapUtils/GetfacilityTypeData';
import searchFacet from './MyMapUtils/searchFacet';
import CircularProgress from '@material-ui/core/CircularProgress';
import GetManagementStatus from './MyMapUtils/GetManagementStatus';

export default function FilterPanel(props) {
    const [checkedTypes, setCheckedTypes] = useState(props.showFilterInfo.targetTypes);
    const [existsTypes, setExistsTypes] = useState([]);
    const [isSearching, setIsSearching] = useState(true);
    const [date_str, setDate_str] = useState(props.showFilterInfo.DateTime_str);
    const [date_end, setDate_end] = useState(props.showFilterInfo.DateTime_end);
    const [checkedType, setCheckedType] = useState(props.showFilterInfo.targetType);

    function onClearClick() {
        setCheckedTypes([]);
        setDate_str("");
        setDate_end("");
    }

    const handleClose = () => {
        switch(props.showFilterInfo.popupKind){
            case "date":
                if(date_str !== props.showFilterInfo.DateTime_str || date_end !== props.showFilterInfo.DateTime_end){
                    props.onApplyFilter_date(props.showFilterInfo.filterKind_str,date_str,props.showFilterInfo.filterKind_end,date_end);
                }
                break;
            case "radio":
                if (checkedType !== props.showFilterInfo.targetType) {
                    props.onApplyFilter(props.showFilterInfo.filterKind,checkedType);
                }
                break;
            default:
                if (!stringArrayEquals(props.showFilterInfo.targetTypes, checkedTypes)) {
                    props.onApplyFilter(props.showFilterInfo.filterKind,checkedTypes);
                }
                break;
        }
        
        props.onBack();
    };
    
    useEffect(() => {
        //日付入力の場合は選択肢用の検索をせず、即時表示（ラジオも同様）
        if(props.showFilterInfo.popupKind === "date" || props.showFilterInfo.popupKind === "radio"){
            setIsSearching(false);
        }
        else{
            search();
        }
    }, [props.showFilterInfo.filterKind]);
    
    function search() {
        setIsSearching(true);
        searchFacet(props.showFilterInfo.filterKind, props.userAuthorities, props.keyword, props.filters,props.viewtype)
            .then(response => response.json())
            .then(
                (result) => {
                    console.log(result);
                    procOnSearch(result);
                },
                (error) => {
                    console.log(error);
                }
            )
            .finally(() => {
                setIsSearching(false);
            });
    }
    function procOnSearch(result) {
        // 空白のfacetは取り除く。 nullは取得されないので、空白で検索されると都合が悪い
        let facets = result['@search.facets'][props.showFilterInfo.filterKind].filter(item => item.value !== "");
        // facets に存在しない checkedTypes を追加。
        let toAddFacets = [];
        checkedTypes?.forEach(item => {
            if (!facets.some(facet => facet.value === item)) {
                toAddFacets.push({ value: item, count: 0 });
            }
        });
        facets = facets.concat(toAddFacets);
        // 並べ替え
        facets.sort((a, b) => {
            if (a.value > b.value)
                return 1;
            else
                return -1;
        });
        setExistsTypes(facets);
    }
    
    return (
        <div className="filter-panel" style={props.getStyle()}>
            <div role="main" className="filter-flex">
                <div className="filter-header">
                    <div className="filter-header-buttons-left">
                        <button aria-label="戻る"
                            className="filter-header-back-button"
                            onClick={handleClose}
                        >
                            <i className="bi bi-arrow-left"></i>
                        </button>
                    </div>

                    <div className="filter-header-title">
                        <span>{props.showFilterInfo.label}</span>
                    </div>
                    {props.showFilterInfo.popupKind !== "radio" && 
                        <div className="filter-header-buttons-right">
                            <button
                                className="filter-header-back-button"
                                onClick={onClearClick}
                            >
                                <p className="filter-hovercard-buttontext">リセ</p>
                                <p className="filter-hovercard-buttontext">ット</p>
                            </button>
                        </div>
                    }
                </div>
                <div className="filter-content">
                    {isSearching ?
                            <CircularProgress size={20} />
                            :
                            props.showFilterInfo.popupKind === "date"?
                            
                                <div className="filter-hovercard-filmingDate">
                                    <input type="date"
                                        value={date_str}
                                        onChange={(e)=>setDate_str(e.target.value)}
                                        max={date_end}
                                        />
                                    <span style={{margin:'0 5px'}}>～</span>
                                    <input type="date"
                                        value={date_end}
                                        onChange={(e)=>setDate_end(e.target.value)}
                                        min={date_str}
                                        />
                                </div>
                            :
                            props.showFilterInfo.popupKind === "radio" ?
                            <ul role="group" className="hovercard-items">
                                <li key={"pavement100"} aria-checked="false" role="radio" className="hovercard-item" onClick={() => {setCheckedType("pavement100")}}>
                                    <div className="hovercard-check">
                                        <i className={checkedType === "pavement100" ? "bi bi-circle-fill" : "bi bi-circle"}></i>
                                    </div>
                                    <div className="hovercard-text">
                                            <span>100ｍ単位</span>
                                    </div>
                                </li>
                                <li key={"pavement10"} aria-checked="false" role="radio" className="hovercard-item" onClick={() => {setCheckedType("pavement10")}}>
                                    <div className="hovercard-check">
                                        <i className={checkedType === "pavement10" ? "bi bi-circle-fill" : "bi bi-circle"}></i>
                                    </div>
                                    <div className="hovercard-text">
                                            <span>10ｍ単位</span>
                                    </div>
                                </li>
                                
                            </ul>
                            :
                            <ul role="group" className="hovercard-items">
                            {existsTypes && existsTypes.map((existsType) =>
                                <li key={existsType.value} aria-checked="false" role="checkbox" className="hovercard-item" onClick={() => {
                                    let newCheckedTypes
                                    if (checkedTypes.includes(existsType.value)) {
                                        newCheckedTypes = checkedTypes.filter(type => type !== existsType.value)
                                    } else {
                                        newCheckedTypes = [...checkedTypes, existsType.value]
                                    }
                                    sortValues(newCheckedTypes);
                                    setCheckedTypes(newCheckedTypes);
                                }}>
                                    <div className="hovercard-check">
                                        <i className={checkedTypes.includes(existsType.value) ? "bi bi-check-square-fill" : "bi bi-square"}></i>
                                    </div>

                                    {props.showFilterInfo.isFacilityType &&
                                        <div className="hovercard-image"><img src={GetfacilityTypeData(existsType.value,"icon")} className="facility-icon" alt="" /></div>
                                    }
                                    <div className="hovercard-text">
                                            <span>
                                                {props.showFilterInfo.isFacilityType ?
                                                    GetfacilityTypeData(existsType.value,"name")
                                                    :
                                                    props.showFilterInfo.masterKind ?
                                                        GetManagementStatus(props.showFilterInfo.masterKind,existsType.value,"name")
                                                        :
                                                        existsType.value
                                                }
                                            </span>
                                            <span className="hovercard-count"> ({existsType.count})</span>
                                        </div>
                                </li>
                                
                            )}
                            </ul>
                        }
                    </div>
                    
            </div>
        </div>
    );

}

function sortValues(arr) {
    arr.sort((a, b) => {
        if (a > b)
            return 1;
        else
            return -1;
    });
}
function stringArrayEquals(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;
    for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) return false;
    }
    return true;
}